import { createContext, useCallback, useState } from "react";
import FetchingFallback from "components/StatusHandler/components/FetchingFallback";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";

function Loader() {
  return (
    <ThemeProvider2024>
      <FetchingFallback size="large" />
    </ThemeProvider2024>
  );
}

export type InitialLoaderType = boolean;

export const InitialLoaderContext = createContext<InitialLoaderType | undefined>(undefined);
InitialLoaderContext.displayName = "InitialLoaderContext";

export type InitialLoaderActionsType = (value: boolean) => void;

export const InitialLoaderActionsContext = createContext<InitialLoaderActionsType | undefined>(undefined);
InitialLoaderActionsContext.displayName = "InitialLoaderActionsContext";

interface InitialLoaderProviderProps {
  children?: React.ReactNode;
}

function InitialLoaderProvider(props: InitialLoaderProviderProps) {
  const [loading, setLoading] = useState(true);

  const onSetLoading = useCallback((value: boolean) => {
    setLoading(value);
  }, []);

  return (
    <InitialLoaderContext.Provider value={loading}>
      <InitialLoaderActionsContext.Provider value={onSetLoading}>
        {props.children}
        {loading ? <Loader /> : null}
      </InitialLoaderActionsContext.Provider>
    </InitialLoaderContext.Provider>
  );
}

export default InitialLoaderProvider;
